import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);

const service = axios.create({
  timeout: 30000
});

function createError(error) {
  const { message, config, request, response } = error;
  const { data } = response;

  const newError = new Error(message);
  newError.Code = data.Code;
  newError.Message = data.Message;

  newError.config = config;
  newError.request = request;
  newError.response = response;

  return newError;
}

async function create(config) {
  try {
    const { url } = config;
    if (!url.startsWith("/")) {
      config.url = "/" + url;
    }
    const { data } = await service(config);
    return data;
  } catch (error) {
    const newError = createError(error)
    Toast({
      message: newError.Message,
      duration: 1000,
      forbidClick: true
    });
    throw createError(newError);
  }
}

export default create;
